import React from "react";
import { LoadingError } from "../../components";
import { Table } from "../../components/Molecules/Table/Table";
import {
  DATE_FORMAT,
  ORDERS_COLUMNS_DEFINE,
} from "../../constants/AppConstants";
import { Orders } from "../../types/ApiTypes";
import moment from "moment";
import { capitalize } from "../../../shared/utils/stringUtils";

export const OrdersApptTable = ({
  res,
  loading,
  columns,
  error,
}: {
  res?: Orders[];
  loading?: boolean;
  columns: string[];
  error?: boolean;
}) => {
  const userColumns = ORDERS_COLUMNS_DEFINE.map((item, idx) => ({
    ...item,
    idx,
  })).filter((item) => columns.includes(item.id));
  const columnsIndexes = userColumns.map((item) => item.idx);
  const tableData =
    res &&
    res
      .map((item) => [
        moment(item.commAt).format(`${DATE_FORMAT} hh:mm A`),
        capitalize(item.patientID),
        `${capitalize(item.firstName)} ${capitalize(item.lastName)}`,
        capitalize(item.location),
        capitalize(item.commModality),
        capitalize(item.commTo),
        capitalize(item.orderNumber),
        capitalize(item.itemType),
        capitalize(item.commStatusText),
        capitalize(item.response),
      ])
      .map((item) => item.filter((_, idx) => columnsIndexes.includes(idx)));

  return !error ? (
    <>
      <Table
        colums={userColumns.map((item) => item.label)}
        datas={tableData || []}
        loading={loading}
      />
    </>
  ) : (
    <LoadingError />
  );
};
